// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Leaflet from "leaflet";
import * as Caml_obj from "../../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as MapConfig from "../map-mods-tbd-catalyst/utils/MapConfig.bs.js";
import * as Belt_Array from "../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as LeafletMap from "./LeafletMap.bs.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactModal from "react-modal";
import * as LeafletHooks from "../map-mods-tbd-catalyst/leaflet/bindings/LeafletHooks.bs.js";
import * as LeafletPopup from "../map-mods-tbd-catalyst/leaflet/views/LeafletPopup.bs.js";
import * as Interpolation from "../helper/Interpolation.bs.js";
import * as LeafletHelper from "../map-mods-tbd-catalyst/leaflet/views/LeafletHelper.bs.js";
import * as ReactLeaflet from "react-leaflet";
import * as LegendComponent from "./LegendComponent.bs.js";
import * as OrderMarkersMapper from "../view-mappers/OrderMarkersMapper.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as OrderPolylineMapper from "../view-mappers/OrderPolylineMapper.bs.js";
import * as VehicleTracerMapper from "../view-mappers/VehicleTracerMapper.bs.js";
import * as LeafletIconComponent from "../map-mods-tbd-catalyst/leaflet/views/LeafletIconComponent.bs.js";
import * as VehicleTracerComponent from "./VehicleTracerComponent.bs.js";
import * as MapMarkerRotationVariant from "./MapMarkerRotationVariant.bs.js";
import * as DefaultVehicleLocationMapper from "../view-mappers/DefaultVehicleLocationMapper.bs.js";

import 'leaflet/dist/leaflet.css'
;

import 'leaflet-rotatedmarker'
;

function s(prim) {
  return prim;
}

var markerIconArr = [
  LeafletIconComponent.waypointLocationIcon1,
  LeafletIconComponent.waypointLocationIcon2,
  LeafletIconComponent.waypointLocationIcon3
];

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetShowDryRun */0 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: action._0,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetVehicleTimestamp */1 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: action._0,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetVehicleLocation */2 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: action._0,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetErrorModal */3 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: action._0,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: state.popupVisibility
              };
    case /* SetMapLoaded */4 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: action._0,
                popupVisibility: state.popupVisibility
              };
    case /* SetPopupVisibility */5 :
        return {
                markers: state.markers,
                polylines: state.polylines,
                showDryRun: state.showDryRun,
                tracerControl: state.tracerControl,
                defaultVehicleLocation: state.defaultVehicleLocation,
                vehicleLocation: state.vehicleLocation,
                isErrorModalVisible: state.isErrorModalVisible,
                isMapLoaded: state.isMapLoaded,
                popupVisibility: action._0
              };
    
  }
}

function setInterpolationTime(value, order_detail, dispatch) {
  var driverRoute = order_detail.driver_route;
  if (driverRoute !== undefined) {
    var currentLocation = Interpolation.getInterpolatedCoordinate(value, driverRoute.line);
    switch (currentLocation.TAG | 0) {
      case /* Interpolated */0 :
          Curry._1(dispatch, {
                TAG: /* SetErrorModal */3,
                _0: false
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleTimestamp */1,
                _0: {
                  ts: Caml_option.some(value)
                }
              });
          return Curry._1(dispatch, {
                      TAG: /* SetVehicleLocation */2,
                      _0: currentLocation._0
                    });
      case /* ErrorBelowLowest */1 :
          Curry._1(dispatch, {
                TAG: /* SetErrorModal */3,
                _0: true
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: currentLocation._0
              });
          return Curry._1(dispatch, {
                      TAG: /* SetVehicleTimestamp */1,
                      _0: {
                        ts: Caml_option.some(Caml_array.get(driverRoute.line, 0).ts)
                      }
                    });
      case /* ErrorAboveHighest */2 :
          Curry._1(dispatch, {
                TAG: /* SetErrorModal */3,
                _0: true
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: currentLocation._0
              });
          return Curry._1(dispatch, {
                      TAG: /* SetVehicleTimestamp */1,
                      _0: {
                        ts: Caml_option.some(Caml_array.get(driverRoute.line, driverRoute.line.length - 1 | 0).ts)
                      }
                    });
      
    }
  } else {
    Curry._1(dispatch, {
          TAG: /* SetErrorModal */3,
          _0: false
        });
    Curry._1(dispatch, {
          TAG: /* SetVehicleTimestamp */1,
          _0: {
            ts: undefined
          }
        });
    return Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: undefined
              });
  }
}

function markerCount(groupedMarkerList, waypoints) {
  var staticMarker = List.length(List.filter(Belt_Option.isSome)(List.flatten(groupedMarkerList)));
  var waypointMarker = Belt_Option.mapWithDefault(waypoints, 0, (function (arr) {
          return arr.length;
        }));
  return (staticMarker + 1 | 0) + waypointMarker | 0;
}

function LeafletOrderMapComponent(Props) {
  var order_detail = Props.order_detail;
  var order_id = Props.order_id;
  var initialState_markers = OrderMarkersMapper.getMarkersViews(order_detail.locations, order_detail.status, order_detail.driver_route);
  var initialState_polylines = OrderPolylineMapper.getPolylineViews(order_detail.trip_started_time, order_detail.driver_route);
  var initialState_tracerControl = {
    ts: undefined
  };
  var initialState_defaultVehicleLocation = DefaultVehicleLocationMapper.getVehicleDefaultLocation(order_detail.status);
  var initialState_popupVisibility = [];
  var initialState = {
    markers: initialState_markers,
    polylines: initialState_polylines,
    showDryRun: true,
    tracerControl: initialState_tracerControl,
    defaultVehicleLocation: initialState_defaultVehicleLocation,
    vehicleLocation: undefined,
    isErrorModalVisible: false,
    isMapLoaded: undefined,
    popupVisibility: initialState_popupVisibility
  };
  var match = React.useState(function () {
        return null;
      });
  var map = match[0];
  var match$1 = React.useState(function () {
        return null;
      });
  var match$2 = React.useReducer(reducer, initialState);
  var dispatch = match$2[1];
  var state = match$2[0];
  var isTracerPresent = {
    contents: false
  };
  var map_elem_id = "order-map-" + order_id;
  var groupedMarkers = OrderMarkersMapper.groupMarkers(state.markers);
  var centerLocation = OrderMarkersMapper.getMarkerLatLng(order_detail.locations.pickup_loc.location);
  var match$3 = order_detail.locations.accepted_loc;
  var acceptedLocationWithTime = match$3 !== undefined ? (
      match$3.TAG === /* WithTime */0 ? match$3._0 : ({
            point: match$3._0,
            ts: Timestamp$Catalyst.now(undefined)
          })
    ) : ({
        point: {
          lat: 0.0,
          lng: 0.0
        },
        ts: Timestamp$Catalyst.now(undefined)
      });
  var coord = order_detail.locations.pickup_loc.location;
  var pickupLocationWithTime;
  pickupLocationWithTime = coord.TAG === /* WithTime */0 ? coord._0 : ({
        point: coord._0,
        ts: Timestamp$Catalyst.now(undefined)
      });
  var loc = order_detail.locations.trip_started_loc;
  var tripStartedLocationWithTime;
  if (loc !== undefined) {
    var coord$1 = loc.location;
    tripStartedLocationWithTime = coord$1.TAG === /* WithTime */0 ? coord$1._0 : ({
          point: coord$1._0,
          ts: Timestamp$Catalyst.now(undefined)
        });
  } else {
    tripStartedLocationWithTime = null;
  }
  var loc$1 = order_detail.locations.trip_ended_loc;
  var tripEndedLocationWithTime;
  if (loc$1 !== undefined) {
    var coord$2 = loc$1.location;
    tripEndedLocationWithTime = coord$2.TAG === /* WithTime */0 ? coord$2._0 : ({
          point: coord$2._0,
          ts: Timestamp$Catalyst.now(undefined)
        });
  } else {
    tripEndedLocationWithTime = null;
  }
  var markerData = state.markers.cancelled;
  var cancelledLocationWithTime;
  if (markerData !== undefined) {
    var ts = markerData.tooltip.ts;
    cancelledLocationWithTime = {
      point: markerData.location,
      ts: ts !== undefined ? Timestamp$Catalyst.dateStringToTimestamp(ts, "Do MMM' YY, HH:mm") : Timestamp$Catalyst.now(undefined)
    };
  } else {
    cancelledLocationWithTime = null;
  }
  var coord$3 = order_detail.locations.drop_loc.location;
  var dropLocationWithTime;
  dropLocationWithTime = coord$3.TAG === /* WithTime */0 ? coord$3._0 : ({
        point: coord$3._0,
        ts: Timestamp$Catalyst.now(undefined)
      });
  var locArray = order_detail.locations.waypoint_locs;
  var waypointWithTime = locArray !== undefined ? locArray.map(function (item) {
          var coord = item.location;
          if (coord.TAG === /* WithTime */0) {
            return coord._0;
          } else {
            return {
                    point: coord._0,
                    ts: Timestamp$Catalyst.now(undefined)
                  };
          }
        }) : [];
  var route = state.polylines.billed;
  var billedPolyline = route !== undefined ? route.map(function (item) {
          return [
                  item.lat,
                  item.lng
                ];
        }) : [];
  var route$1 = state.polylines.dry_run;
  var dryRunPolyline = route$1 !== undefined ? route$1.map(function (item) {
          return [
                  item.lat,
                  item.lng
                ];
        }) : [];
  var loc$2 = order_detail.locations.trip_started_loc;
  var tripStartedLocationAddress = loc$2 !== undefined ? loc$2.address : "";
  var loc$3 = order_detail.locations.trip_ended_loc;
  var tripEndedLocationAddress = loc$3 !== undefined ? loc$3.address : "";
  var markerData$1 = state.markers.cancelled;
  var cancelledLocationAddress;
  if (markerData$1 !== undefined) {
    var address = markerData$1.tooltip.address;
    cancelledLocationAddress = address !== undefined ? address : "";
  } else {
    cancelledLocationAddress = "";
  }
  var loc$4 = state.vehicleLocation;
  var vehiclePosition = loc$4 !== undefined ? [
      loc$4.lat,
      loc$4.lng
    ] : [
      0.0,
      0.0
    ];
  var getMarkerRotationVariant = function (stateMarker) {
    var markerGroups = List.filter(function (markerGroup) {
            var marker = List.nth(markerGroup, 0);
            if (marker !== undefined && Caml_obj.caml_equal(marker, stateMarker)) {
              return true;
            } else {
              return false;
            }
          })(groupedMarkers);
    var match = List.length(markerGroups);
    if (match === 0) {
      return /* Right */1;
    }
    var marker = List.nth(markerGroups, 0);
    var match$1 = List.length(marker);
    if (match$1 === 0 || match$1 === 1) {
      return /* Straight */2;
    } else {
      return /* Left */0;
    }
  };
  var hamburgerMenuHandler = function (menu) {
    if (menu) {
      return Curry._1(dispatch, {
                  TAG: /* SetShowDryRun */0,
                  _0: true
                });
    } else {
      return Curry._1(dispatch, {
                  TAG: /* SetShowDryRun */0,
                  _0: false
                });
    }
  };
  var modalContent = function (param) {
    return React.createElement("div", {
                className: "order-map-modal-container"
              }, React.createElement("div", {
                    className: "message"
                  }, "Selected value is not within the trip time range."), React.createElement("button", {
                    className: "close-button",
                    onClick: (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* SetErrorModal */3,
                                    _0: false
                                  });
                      })
                  }, "Okay"));
  };
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetVehicleTimestamp */1,
                _0: {
                  ts: VehicleTracerMapper.getVehicleTracerDefaultTime(state.defaultVehicleLocation, order_detail.driver_route)
                }
              });
          Curry._1(dispatch, {
                TAG: /* SetVehicleLocation */2,
                _0: VehicleTracerMapper.getVehicleDefaultLocation(state.defaultVehicleLocation, order_detail.driver_route)
              });
          
        }), []);
  React.useEffect((function () {
          if (map == null) {
            
          } else {
            Curry._1(LeafletHooks.addVectorTiles, map);
          }
          return (function (param) {
                    
                  });
        }), [map]);
  var match$4 = state.tracerControl.ts;
  var match$5 = order_detail.driver_route;
  var tmp;
  if (tripStartedLocationWithTime == null) {
    tmp = null;
  } else {
    var marker = state.markers.trip_start;
    var marker$1 = state.markers.trip_start;
    var marker$2 = state.markers.trip_start;
    tmp = React.createElement(ReactLeaflet.Marker, {
          children: React.createElement(LeafletPopup.make, {
                title: "Trip Started",
                address: tripStartedLocationAddress,
                time_stamp: tripStartedLocationWithTime.ts
              }),
          position: [
            tripStartedLocationWithTime.point.lat,
            tripStartedLocationWithTime.point.lng
          ],
          interactive: true,
          icon: Leaflet.icon(LeafletIconComponent.getLeafletIcon(marker !== undefined ? marker : state.markers.drop, getMarkerRotationVariant(marker$1 !== undefined ? marker$1 : state.markers.drop))),
          rotationAngle: MapMarkerRotationVariant.getMarkerRotation(getMarkerRotationVariant(marker$2 !== undefined ? marker$2 : state.markers.drop)),
          rotationOrigin: "bottom"
        });
  }
  var tmp$1;
  if (tripEndedLocationWithTime == null) {
    tmp$1 = null;
  } else {
    var marker$3 = state.markers.trip_end;
    var marker$4 = state.markers.trip_end;
    var marker$5 = state.markers.trip_end;
    tmp$1 = React.createElement(ReactLeaflet.Marker, {
          children: React.createElement(LeafletPopup.make, {
                title: "Trip Ended",
                address: tripEndedLocationAddress,
                time_stamp: tripEndedLocationWithTime.ts
              }),
          position: [
            tripEndedLocationWithTime.point.lat,
            tripEndedLocationWithTime.point.lng
          ],
          interactive: true,
          icon: Leaflet.icon(LeafletIconComponent.getLeafletIcon(marker$3 !== undefined ? marker$3 : state.markers.drop, getMarkerRotationVariant(marker$4 !== undefined ? marker$4 : state.markers.drop))),
          rotationAngle: MapMarkerRotationVariant.getMarkerRotation(getMarkerRotationVariant(marker$5 !== undefined ? marker$5 : state.markers.drop)),
          rotationOrigin: "bottom"
        });
  }
  var tmp$2;
  if (cancelledLocationWithTime == null) {
    tmp$2 = null;
  } else {
    var marker$6 = state.markers.cancelled;
    var marker$7 = state.markers.cancelled;
    var marker$8 = state.markers.cancelled;
    tmp$2 = React.createElement(ReactLeaflet.Marker, {
          children: React.createElement(LeafletPopup.make, {
                title: "Cancelled",
                address: cancelledLocationAddress,
                time_stamp: cancelledLocationWithTime.ts
              }),
          position: [
            cancelledLocationWithTime.point.lat,
            cancelledLocationWithTime.point.lng
          ],
          interactive: true,
          icon: Leaflet.icon(LeafletIconComponent.getLeafletIcon(marker$6 !== undefined ? marker$6 : state.markers.drop, getMarkerRotationVariant(marker$7 !== undefined ? marker$7 : state.markers.drop))),
          rotationAngle: MapMarkerRotationVariant.getMarkerRotation(getMarkerRotationVariant(marker$8 !== undefined ? marker$8 : state.markers.drop)),
          rotationOrigin: "bottom"
        });
  }
  var tmp$3;
  if (acceptedLocationWithTime == null) {
    tmp$3 = null;
  } else {
    var marker$9 = state.markers.accept;
    var marker$10 = state.markers.accept;
    var marker$11 = state.markers.accept;
    tmp$3 = React.createElement(ReactLeaflet.Marker, {
          children: React.createElement(LeafletPopup.make, {
                title: "Trip Accepted",
                address: "",
                time_stamp: acceptedLocationWithTime.ts
              }),
          position: [
            acceptedLocationWithTime.point.lat,
            acceptedLocationWithTime.point.lng
          ],
          interactive: true,
          icon: Leaflet.icon(LeafletIconComponent.getLeafletIcon(marker$9 !== undefined ? marker$9 : state.markers.drop, getMarkerRotationVariant(marker$10 !== undefined ? marker$10 : state.markers.drop))),
          rotationAngle: MapMarkerRotationVariant.getMarkerRotation(getMarkerRotationVariant(marker$11 !== undefined ? marker$11 : state.markers.drop)),
          rotationOrigin: "bottom"
        });
  }
  var ts$1 = state.tracerControl.ts;
  return React.createElement("div", {
              className: "order-map-container"
            }, match$4 !== undefined && match$5 !== undefined ? (isTracerPresent.contents = true, React.createElement(VehicleTracerComponent.make, {
                      setInterpolationTime: (function (param) {
                          return setInterpolationTime(param, order_detail, dispatch);
                        }),
                      order_status: order_detail.status,
                      hamburgerMenuHandler: hamburgerMenuHandler,
                      time_stamp: Caml_option.valFromOption(match$4),
                      min_date: Caml_array.get(match$5.line, 0).ts,
                      max_date: Caml_array.get(match$5.line, match$5.line.length - 1 | 0).ts
                    })) : null, React.createElement(LeafletMap.make, {
                  children: null,
                  isTracerPresent: isTracerPresent
                }, React.createElement(ReactLeaflet.MapContainer, {
                      children: null,
                      center: [
                        centerLocation.lat,
                        centerLocation.lng
                      ],
                      id: map_elem_id,
                      style: {
                        backgroundColor: "#ffffff",
                        height: "93%",
                        width: "100%",
                        zIndex: "1"
                      },
                      zoom: 14,
                      maxZoom: 17,
                      minZoom: 3,
                      zoomControl: true
                    }, React.createElement(ReactLeaflet.Marker, {
                          children: React.createElement(LeafletPopup.make, {
                                title: "Pickup Location",
                                address: order_detail.locations.pickup_loc.address,
                                time_stamp: pickupLocationWithTime.ts
                              }),
                          position: [
                            pickupLocationWithTime.point.lat,
                            pickupLocationWithTime.point.lng
                          ],
                          interactive: true,
                          icon: Leaflet.icon(LeafletIconComponent.getLeafletIcon(state.markers.pickup, getMarkerRotationVariant(state.markers.pickup))),
                          rotationAngle: MapMarkerRotationVariant.getMarkerRotation(getMarkerRotationVariant(state.markers.pickup)),
                          rotationOrigin: "bottom"
                        }), React.createElement(ReactLeaflet.Marker, {
                          children: React.createElement(LeafletPopup.make, {
                                title: "Drop Location",
                                address: order_detail.locations.drop_loc.address,
                                time_stamp: dropLocationWithTime.ts
                              }),
                          position: [
                            dropLocationWithTime.point.lat,
                            dropLocationWithTime.point.lng
                          ],
                          interactive: true,
                          icon: Leaflet.icon(LeafletIconComponent.getLeafletIcon(state.markers.drop, getMarkerRotationVariant(state.markers.drop))),
                          rotationAngle: MapMarkerRotationVariant.getMarkerRotation(getMarkerRotationVariant(state.markers.drop)),
                          rotationOrigin: "bottom"
                        }), tmp, tmp$1, tmp$2, tmp$3, React.createElement(ReactLeaflet.Marker, {
                          children: React.createElement(LeafletPopup.make, {
                                title: "vehicle Loction",
                                address: "",
                                time_stamp: ts$1 !== undefined ? Caml_option.valFromOption(ts$1) : pickupLocationWithTime.ts
                              }),
                          position: vehiclePosition,
                          interactive: true,
                          icon: Leaflet.icon(LeafletIconComponent.getVehicleIcon(order_detail.vehicle_type))
                        }), Belt_Array.mapWithIndex(waypointWithTime, (function (idx, coord) {
                            var tmp;
                            switch (idx) {
                              case 0 :
                                  tmp = Caml_array.get(markerIconArr, 0);
                                  break;
                              case 1 :
                                  tmp = Caml_array.get(markerIconArr, 1);
                                  break;
                              case 2 :
                                  tmp = Caml_array.get(markerIconArr, 2);
                                  break;
                              default:
                                if (idx === (waypointWithTime.length - 1 | 0)) {
                                  var marker = state.markers.accept;
                                  var marker$1 = state.markers.accept;
                                  tmp = Leaflet.icon(LeafletIconComponent.getLeafletIcon(marker !== undefined ? marker : state.markers.drop, getMarkerRotationVariant(marker$1 !== undefined ? marker$1 : state.markers.drop)));
                                } else {
                                  tmp = Leaflet.icon(LeafletIconComponent.getVehicleIcon(order_detail.vehicle_type));
                                }
                            }
                            return React.createElement(ReactLeaflet.Marker, {
                                        children: React.createElement(LeafletPopup.make, {
                                              title: "Waypoint Location",
                                              address: "",
                                              time_stamp: coord.ts
                                            }),
                                        position: [
                                          coord.point.lat,
                                          coord.point.lng
                                        ],
                                        interactive: true,
                                        icon: tmp,
                                        key: String(idx)
                                      });
                          })), React.createElement(ReactLeaflet.Polyline, {
                          children: null,
                          positions: billedPolyline,
                          pathOptions: {
                            stroke: true,
                            color: MapConfig.primaryPolylineColour,
                            weight: 4
                          }
                        }), React.createElement(ReactLeaflet.Polyline, {
                          children: null,
                          positions: dryRunPolyline,
                          pathOptions: {
                            stroke: true,
                            color: MapConfig.secondaryPolylineColour,
                            weight: 4
                          }
                        }), React.createElement(LeafletHelper.make, {
                          order_details: order_detail,
                          setMap: match[1],
                          setBounds: match$1[1]
                        })), React.createElement(LegendComponent.make, {}), state.isErrorModalVisible ? React.createElement(ReactModal, {
                        isOpen: true,
                        onRequestClose: (function (param) {
                            return Curry._1(dispatch, {
                                        TAG: /* SetErrorModal */3,
                                        _0: false
                                      });
                          }),
                        overlayClassName: "porter-form__modal-overlay",
                        className: "porter-form__modal acknowledgeRelaseModal",
                        shouldCloseOnOverlayClick: true,
                        children: modalContent(undefined)
                      }) : null));
}

var make = LeafletOrderMapComponent;

export {
  s ,
  markerIconArr ,
  reducer ,
  setInterpolationTime ,
  markerCount ,
  make ,
  
}
/*  Not a pure module */
